import { create } from 'zustand';
import { permissionService, type PermissionData } from '../services/permissionService';

interface PermissionState {
  permissions: PermissionData[];
  
  getPermissionsList: () => Promise<PermissionData[]>;
}

export const usePermissionStore = create<PermissionState>((set) => ({
  permissions: [],

  getPermissionsList: async () => {
    try {
      const response = await permissionService.getPermissionsList();
      
      set({
        permissions: response,
      });
      
      return response;
    } catch (error) {
      console.error('Error fetching Permissions:', error);
      throw error;
    }
  },
}));
